import { offerPosterModalData } from '@spo/logic';
import { SpoUserSettingsResponse } from '@spo/types';
import { useQuery } from '@tanstack/react-query';

export const useSportOfferPosterModal = (
  userConfiguration: SpoUserSettingsResponse | undefined,
) => {
  return useQuery({
    queryKey: ['useSportOfferPosterModal', userConfiguration],
    queryFn: () => {
      if (userConfiguration) {
        return offerPosterModalData.getDataSport(userConfiguration);
      }
    },
    enabled: !!userConfiguration,
  });
};
